import { formatTime } from "../modules/exam/libs/timeformate.js";
export default {
    data() {
        return {
            toName: '',
        }
    },
    watch: {
        "questionsList" : {
            handler: function(newV) {
                let arr = [];
                arr = newV.filter((item) => {
                    return item.result === 1;
                })
                this.rightCount = arr.length;
            },
            deep: true,
        },
    },
    beforeRouteEnter (to, from, next) {
        // ...
        
        next( vm => {
            vm.toName = to.name
        });
    },
    methods: {
        // 单个题目提交
        async singleCommit(val, type) {
            if(this.toName === 'testTrain'){
                this.singleParams = {
                    answerList: [val],
                    commitTime: formatTime(new Date()),
                    practiceId: this.examParams.userPracticeId,
                };
            } 
            await this.$api.testTrain.commitPaper(this.singleParams);
            if((this.currentRanking !== this.examTotal || type === 'next') && this.questionsList[this.currentRanking-1].result === 1){
                this.changeTopic('next');     
            }
        },
        findSomeOne() {
            this.moreanswer = [];
            this.chooseNum = null;
            this.allAnswer.forEach(val => {
                if(val.questionId === this.currentQuestion.options[0].questionId && val.answer) {
                    if(this.currentQuestion.type === 2){
                        this.moreanswer = val.answer.split(',').filter(str => { return !!str});
                    } else {
                        this.chooseNum = val.answer
                    }
                }
            })
        },
        // 跳转到指定题目
        toThisOne(index) {
            this.currentRanking = index+1;
            this.isSheetShow = false;
            this.currentQuestion = this.questionsList[index];
            if(this.moreChoose){
                this.repetAnswer(this.moreChoose)
            }
            this.findSomeOne();
        },
        // 去重
        repetAnswer(params) {
            if (!params) return false;
            if (this.allAnswer.length > 0) {
                this.allAnswer.forEach(item => {
                    if (params.questionId === item.questionId) {
                        this.allAnswer.splice(this.allAnswer.indexOf(item), 1);
                        this.ismark === 1
                            ? (params.mark = 1)
                            : (params.mark = 0);
                    }
                });
            }
            this.allAnswer.push(params);
        },
         // 切换题目
         async changeTopic(type) {
            let num = this.questionsList.indexOf(this.currentQuestion);
            if(this.justWatch && this.watchSetChoosedIndex==1){ //查看练习并筛选错题和未答题时
                let leftArr = [],rightArr=[];
                this.errorUnansweredIndexList.forEach((item)=>{
                    if(item<num){
                        leftArr.push(item)
                    }else if(item>num){
                        rightArr.push(item)
                    }
                })
                if(leftArr.length==0 && type==="prev" || rightArr.length==0 && type==="next"){
                    this.$toast("暂无错题、未答题");
                    return;
                }
                if(type==="prev"){
                    num = leftArr[leftArr.length-1];
                }else if(type==="next"){
                    num = rightArr[0];
                }
            }else{
                if(num !== 0 && type === "prev"){
                    num =num - 1;
                }else if(num+1< this.examTotal && type === "next"){
                   num = num + 1;
                }else{
                    return;
                }
            }
            this.pushState();
            this.chooseNum = null;
            this.currentQuestion = this.questionsList[num];
            this.currentRanking = num + 1;
            if (!this.justWatch) {
                this.findSomeOne();
            }
        },
        setColor(item) {
            if (item.result === 1 && item.reply) {
                return "answeredTopic";
            } else if (item.result === 0 && item.reply) {
                return "errorTopic";
            }
            if (!item.reply) {
                return "unansweredTopic";
            }
        },
        chooseColor(item) {
            let hasOne =
                this.moreanswer &&
                this.moreanswer.length > 0 &&
                this.moreanswer.indexOf(item.optionNumber) !== -1;
            let chooseOne = this.chooseNum === item.optionNumber;
            let rightOne =
                item.optionNumber === this.currentQuestion.rightAnswer;
            let errorOne = !rightOne;
            if (!this.justWatch && (chooseOne || hasOne) && !this.currentQuestion.reply) {
                return "activeSpan";
            } else if (this.justWatch || this.currentQuestion.reply) {
                let moreRightOne =
                    this.currentQuestion.rightAnswer.indexOf(
                        item.optionNumber
                    ) !== -1 &&
                    this.currentQuestion.userAnswer &&
                    this.currentQuestion.userAnswer.indexOf(
                        item.optionNumber
                    ) !== -1;
                let moreErrorOne =
                    this.currentQuestion.rightAnswer.indexOf(
                        item.optionNumber
                    ) !== -1 && this.currentQuestion.type === 2;
                if (
                    (chooseOne && rightOne) ||
                    (hasOne && !errorOne) ||
                    moreRightOne
                ) {
                    return "activeSpan";
                } else if ((chooseOne && errorOne) || (errorOne && hasOne)) {
                    return "cuoSpan";
                } else if (moreErrorOne) {
                    return "activeSpan 1";
                }
            } else {
                return "";
            }
        },

    },
}